<script setup>
import { useRouter } from 'vue-router';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { ButtonComponent } from '@/components';
import { useScreenSize } from '@/composables/useScreenSize';

const store = useStore();
const { screenSize } = useScreenSize();
const isMobile = computed(() => screenSize.value === 'mobile');

const router = useRouter();
const { containerClass } = defineProps({
  containerClass: {
    type: String,
    required: false,
    default: 'w-full',
  },
});

const canViewTFX = computed(() =>
  store.state.users.currentUser?.scopes?.includes('carrier_view_posted_loads')
);
</script>

<template>
  <div
    v-if="canViewTFX"
    class="z-[1] flex flex-col items-center justify-center gap-2 overflow-hidden rounded-xl bg-white p-4 outline outline-1 outline-offset-[-1px] outline-neutral-300-a"
    :class="[containerClass, { 'mt-5 shadow-md': !isMobile }]"
  >
    <div class="flex h-[75px] flex-col items-center">
      <div class="flex">
        <img
          class="w-[35px]"
          src="@/assets/highway-tfx-logo.svg"
          alt="tfx logo"
        />
      </div>
      <div
        class="z-[1] -mt-2 flex flex-col items-start justify-start gap-0.5 self-stretch overflow-hidden"
      >
        <div
          class="w-full text-center font-['Poppins'] text-base font-semibold leading-normal tracking-tight"
        >
          Search real loads from real brokers
        </div>
        <div
          class="text-color-text-neutral-subtlest-default justify-start self-stretch text-center font-['Poppins'] text-sm font-medium leading-tight tracking-tight"
        >
          The Trusted Freight Exchange is live!
        </div>
      </div>
    </div>
    <ButtonComponent
      variant="primary"
      class="w-full"
      @click="router.push('carrier/exchange/access/benefits')"
    >
      Get Started
    </ButtonComponent>
  </div>
</template>
